/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
/* eslint-disable import/no-unresolved, import/default */

import entityTableTemplate from '../table/entity-table.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function ApplicationRoutes($stateProvider, $injector) {

    var types = $injector.get('types');

    $stateProvider
        .state('home.applications', {
            url: '/applications',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value,
                   types.authority.SUB_CUSTOMER_ADMIN.value, types.authority.SUB_CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'application.applications'
            },
            ncyBreadcrumb: {
                label: '{"icon": "apps", "label": "application.applications"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, applicationTableConfig) {
                        return applicationTableConfig.getConfig($stateParams);
                    }
            }
        })
        .state('home.subCustomers.applications', {
            url: '/:subCustomerId/applications',
            module: 'private',
            auth: [types.authority.CUSTOMER_ADMIN.value, types.authority.CUSTOMER_USER.value],
            views: {
                "content@home": {
                    templateUrl: entityTableTemplate,
                    controllerAs: 'vm',
                    controller: 'EntityTableController'
                }
            },
            data: {
                searchEnabled: false,
                pageTitle: 'gateway.gateways'
            },
            ncyBreadcrumb: {
                label: '{"icon": "apps", "label": "application.applications"}'
            },
            resolve: {
                entityTableConfiguration:
                /*@ngInject*/
                    function($stateParams, applicationTableConfig) {
                        return applicationTableConfig.getConfig($stateParams);
                    }
            }
        });
}



// WEBPACK FOOTER //
// ./src/app/application/application.routes.js